import { mapGetters, mapMutations } from 'vuex';
import applCode from '@/const/applCodeConstants';
import routerNames from '@/const/routerConstants';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', [
      'GET_APP_MAP_DATA',
      'GET_MAP_REASON',
      'GET_APPL_MAP_PARAM',
      'GET_UI_INFO',
      'GET_BIZ_TRIP_GNT_NM',
    ]),
    ...mapGetters('SPINNER', ['GET_APP_LOADING_STATUS']),
    ...mapGetters('ELA', ['GET_APP_MENU']),
    // 연장근무
    isOtWork() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.OtWork;
    },
    // 출퇴근 변경
    isAttend() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Attend;
    },
    // 근무스케쥴 변경
    isSchedule() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Schedule;
    },
    // 보상휴가
    isReward() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Reward;
    },
    // 근태
    isVacation() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Vacation;
    },
    // 취소신청 - 근태
    isCancelVacation() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CancelVacation;
    },
    // 취소신청 - 보상
    isCancelReward() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CancelReward;
    },
    // 제증명
    isCertificate() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.EmpCerti ||
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.EmpCertiEn ||
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CareerCerti ||
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CareerCertiEn
      );
    },
    // 출장신청
    isBizTrip() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.BizTrip;
    },

    /* 호출 view */
    // 신청 완료
    isApplConfirmViewer() {
      return (
        this.appInfoParam.viewerType !== undefined &&
        this.appInfoParam.viewerType === 'applConfirm'
      );
    },
    // 결재함
    isApprDocViewer() {
      return this.$route.name === routerNames.ApprDoc;
    },
    // 내문서함
    isMyBoxViewer() {
      return this.$route.name === routerNames.MyBox;
    },
    // 참조함
    isReferBoxViewer() {
      return this.$route.name === routerNames.ReferBox;
    },
    // 취소메뉴
    isCancelMenu() {
      return this.$route.name === routerNames.CancelMenu;
    },

    confirmTitle() {
      // 신청 완료화면 제목
      if (this.isApplConfirmViewer) {
        let msg = `신청이${
          this.GET_GNT_CD_NM.length > 7 ? '<br>' : ' '
        }완료되었습니다.`;
        if (this.isSchedule) {
          return `근무스케줄 변경 ${msg}`;
        } else if (this.isAttend) {
          return `출퇴근시간 변경 ${msg}`;
        } else if (this.isOtWork) {
          return `연장근무 ${msg}`;
        } else if (this.isCertificate) {
          return `${this.GET_UI_INFO.applNm} 신청이<br/>완료 되었습니다.`;
        } else if (this.isBizTrip) {
          return '출장 신청이 완료 되었습니다.';
          // return `${this.GET_BIZ_TRIP_GNT_NM} 신청이 완료 되었습니다.`; // ** 상세내용에 출장종류가 표기되므로 타이틀은 심플하게 변경
        } else {
          return `${this.GET_GNT_CD_NM}
          ${this.isCancelMenu ? ' 취소' : ' '} ${msg}`;
        }
      }
    },
    cancelApplBtn() {
      return this.cancelBtnShow;
    },
  },
  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP', 'SET_GNT_GUBUN_TMP']),
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },
  destroyed() {
    this.$store.commit('ELA/SET_APP_MAP_DATA', {});
  },
};
